import {useCallback} from 'react';
import {useIsLargeAndUp} from '~/common/hooks/useMatchQuery';
import {SheetOption} from '~/SignUpSheets/components/Header/components/SheetOptions/components/SheetOption/SheetOption';
import {useSheetOptions} from '~/SignUpSheets/components/Header/components/SheetOptions/context/SheetOptionsContext';
import {useSheetActions} from '~/SignUpSheets/hooks/useSheetActions';
import {EditLineIcon} from '~library/svg/EditLineIcon';

export const EditSheet = () => {
  const {editSheet} = useSheetActions();
  const isLargeAndUp = useIsLargeAndUp();
  const {closeOptions} = useSheetOptions();

  const onEditSheet = useCallback(() => {
    editSheet();
    closeOptions();
  }, [editSheet, closeOptions]);

  return (
    <SheetOption
      title={isLargeAndUp ? 'Edit Signup Sheet' : 'Edit sheet'}
      description="Add slots, edit signup details and remove volunteers."
      icon={<EditLineIcon ratio={0.75} />}
      onClick={onEditSheet}
    />
  );
};
